import { render, staticRenderFns } from "./AvailabilityMessage.vue?vue&type=template&id=c5acf6b8"
import script from "./AvailabilityMessage.vue?vue&type=script&lang=js"
export * from "./AvailabilityMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports